export default __webpack_public_path__ + "static/media/kitchen-tools.abc20b5e.png";